import axios from 'axios';

const AGENT_URLS = {
  vidya: `${process.env.REACT_APP_VIDYA_AGENT_URL || 'http://:3001'}/api/health`,
  vidyarthi: `${process.env.REACT_APP_VIDYARTHI_AGENT_URL || 'http://localhost:3002'}/api/health`,
  shikshak: `${process.env.REACT_APP_SHIKSHAK_AGENT_URL || 'http://localhost:3003'}/health`
};

export const checkAgentHealth = async (agentName) => {
  try {
    const response = await axios.get(AGENT_URLS[agentName], { timeout: 5000 });
    return {
      agent: agentName,
      status: 'healthy',
      data: response.data
    };
  } catch (error) {
    return {
      agent: agentName,
      status: 'unhealthy',
      error: error.message
    };
  }
};

export const checkAllAgents = async () => {
  const agents = Object.keys(AGENT_URLS);
  const results = await Promise.allSettled(
    agents.map(agent => checkAgentHealth(agent))
  );
  
  return results.map((result, index) => {
    if (result.status === 'fulfilled') {
      return result.value;
    } else {
      return {
        agent: agents[index],
        status: 'unhealthy',
        error: result.reason?.message || 'Unknown error'
      };
    }
  });
};

export default { checkAgentHealth, checkAllAgents };